<template>
  <headers></headers>
  <router-view />
  <tabbers></tabbers>
</template>

<script setup>
import headers from "@/components/headers.vue";
import tabbers from "@/components/tabbers.vue";

import { onMounted, watch, computed, ref, getCurrentInstance } from "vue";
import { useRouter } from "vue-router";
import { useStore } from "vuex";
const store = useStore();
const router = useRouter();
const { proxy } = getCurrentInstance(); //关键代码


const getanlielist = () => {
  proxy.request("index/productlist", {}).then((res) => {
    store.commit("setproductlist", res.data);
  });
};

const getproductype = () => {
  proxy.request("index/type", {}).then((res) => {
    res.data.reverse().forEach((items, index) => {
      getproduclists(items.id, index);
    });
  });
};
const getproduclists = (ids, indes) => {
  proxy.request("index/lists", { data: { id: ids}}) .then((res) => {
    console.log(ids)
      store.commit("settypelists", {
        arrs:res.data,
        pids:ids,
        ins:indes
      });
  });
};

getanlielist()
getproductype()

const ispc = ref(true);
const setHtmlFontSize = (inse) => {
  console.log(123333)
  var windowWidth = document.documentElement.offsetWidth;
  var htmlFontSize = windowWidth / 750;
  if (windowWidth > 750) {
    ispc.value = true;
    htmlFontSize = 12;
  } else {
    ispc.value = false;
    htmlFontSize = windowWidth / 750;
  }
  store.commit("setispc", ispc.value);
  document.querySelector("html").style.fontSize = htmlFontSize + "px";
  
  if(window.innerWidth > window.innerHeight){
      if(localStorage.getItem('orientation')==2){
        location.reload();    // 重新加载当前页面
      }
  }else{
      if(localStorage.getItem('orientation')==1){
        location.reload();    // 重新加载当前页面
      }
  }
};

const setrientationChange=()=>{
    if(window.innerWidth > window.innerHeight){
       localStorage.setItem('orientation', 1);
    } else {
       localStorage.setItem('orientation', 2);
    }
}

setHtmlFontSize();
setrientationChange();
window.addEventListener("resize", setHtmlFontSize(2));
</script>

<style>
body {
  margin: 0;
  padding: 0;
  background: #fff;
}
.appse {
  height: 60px;
}

@media screen and (max-width: 768px) {
  .htmls p{
    margin: 10rem 0 !important;
  }
  .bodyse {
    margin: 0 30rem;
  }
  .bodyse_blocks {
    padding: 65rem 0 45rem;
  }

  .titles {
    padding: 0 0 50rem;
  }
  .titles_texts {
    font-size: 46rem;
    font-weight: bold;
  }
  .titles_blocks {
    width: 16rem;
    height: 16rem;
    margin-left: 16rem;
    margin-top: 35rem;
  }
  .titles_englis {
    font-size: 20rem;
    padding-top: 15rem;
  }
  .morese {
    width: 150rem;
    height: 56rem;
    font-size: 20rem;
    cursor: pointer;
    margin: 0 auto;
  }

  .caseapps {
    margin-bottom: 30rem;
  }
  .caseapps_items {
    width: 47.5%;
    margin-bottom: 40rem;
  }
  .caseapps_items1 {
    width: 47.5%;
    margin-bottom: 40rem;
  }
  .caseapps_items2 {
    width: 48%;
    margin: 0 0 25rem 0;
  }
  .caseapps_items_images {
    width: 100%;
    height: 200rem !important;
    overflow: hidden;
  }
  .caseapps_items_texts {
    height: 60rem;
    padding: 0 15rem;
  }
  .caseapps_items_names {
    font-size: 26rem;
  }
  .caseapps_items_icons {
    font-size: 26rem !important;
    padding: 4rem;
    margin: 0 0 0 4rem;
    border: 1rem solid #000;
  }
  .caseapps_items_images1 {
    width: 100%;
    height: 300rem !important;
    overflow: hidden;
    border: 1px solid #dddddd;
  }
  .caseapps_items_names1 {
    font-size: 28rem;
    padding-top: 22rem;
    text-align: center;
  }

  .camses_rights {
    text-align: center;
    font-size: 40rem;
    font-weight: 700;
    padding: 30rem 0;
  }
  .camses_htmls {
    padding: 30rem 0;
    border-top: 1rem solid #dbdbdb;
  }
}
@media screen and (min-width: 768px) and (max-width: 1100px) {
  .bodyse {
    width: 760px;
    margin: 0 auto;
  }
  .bodyse_blocks {
    padding: 25px 0 25px;
  }
  .caseapps {
  }
  .caseapps_items {
    width: 24%;
    margin-right: 1.3%;
  }
  .caseapps_items1 {
    width: 19%;
    margin: 0 1.25% 20px 0;
  }
  .caseapps_items2 {
    width: 19%;
    margin: 0 1.25% 20px 0;
  }
  .caseapps_items_images {
    width: 100%;
    height: 120px;
    overflow: hidden;
  }
  .caseapps_items_texts {
    height: 30px;
    padding: 0 6px;
  }
  .caseapps_items_names {
    font-size: 14px;
  }
  .caseapps_items_icons {
    font-size: 14px;
    padding: 2px;
    margin: 0 0 0 2px;
    border: 1px solid #000;
  }
  .caseapps_items_images1 {
    width: 100%;
    height: 120px !important;
    overflow: hidden;
    border: 1px solid #dddddd;
  }
  .caseapps_items_names1 {
    font-size: 12px;
    padding-top: 8px;
    text-align: center;
  }

  .camses {
    width: 220px;
    margin-right: 30px;
  }
  .camses_titles {
    height: 70px;
    padding: 0 12px 0;
    font-size: 14px;
  }
  .camses_lists {
    padding: 0 10px 0 10px;
    height: 50px;
  }
  .camses_lists_texts {
    font-size: 12px;
  }
  .camses_rights {
    text-align: center;
    font-size: 30px;
    font-weight: 700;
    padding: 20px 0;
  }
  .camses_htmls {
    padding: 20px 0;
    border-top: 1px solid #dbdbdb;
  }

  .titles {
    padding: 0 0 25px;
  }
  .titles_texts {
    font-size: 34px;
    font-weight: bold;
  }
  .titles_blocks {
    width: 8px;
    height: 8px;
    margin-left: 8px;
    margin-top: 25px;
  }
  .titles_englis {
    font-size: 12px;
    padding-top: 5px;
  }
  .morese {
    width: 90px;
    height: 35px;
    font-size: 12px;
    cursor: pointer;
  }
}
@media screen and (min-width: 1100px) and (max-width: 1400px) {
  .bodyse {
    width: 1000px;
    margin: 0 auto;
  }
  .bodyse_blocks {
    padding: 40px 0 55px;
  }
  .caseapps {
  }
  .caseapps_items {
    width: 24%;
    margin-right: 1.3%;
  }
  .caseapps_items1 {
    width: 19%;
    margin: 0 1.25% 30px 0;
  }
  .caseapps_items2 {
    width: 19%;
    margin: 0 1.25% 30px 0;
  }
  .caseapps_items_images {
    width: 100%;
    height: 160px !important;
    overflow: hidden;
  }
  .caseapps_items_texts {
    height: 40px;
    padding: 0 10px;
  }
  .caseapps_items_names {
    font-size: 16px;
  }
  .caseapps_items_icons {
    font-size: 16px;
    padding: 3px;
    margin: 0 0 0 3px;
    border: 1px solid #000;
  }
  .caseapps_items_images1 {
    width: 100%;
    height: 160px !important;
    overflow: hidden;
    border: 1px solid #dddddd;
  }
  .caseapps_items_names1 {
    font-size: 14px;
    padding-top: 12px;
    text-align: center;
  }

  .camses {
    width: 280px;
    margin-right: 40px;
  }
  .camses_titles {
    height: 80px;
    padding: 0 20px 0;
    font-size: 18px;
  }
  .camses_lists {
    padding: 0 15px 0 20px;
    height: 55px;
  }
  .camses_lists_texts {
    font-size: 16px;
  }
  .camses_rights {
    text-align: center;
    font-size: 32px;
    font-weight: 700;
    padding: 24px 0;
  }
  .camses_htmls {
    padding: 24px 0;
    border-top: 1px solid #dbdbdb;
  }

  .titles {
    padding: 0 0 35px;
  }
  .titles_texts {
    font-size: 38px;
    font-weight: bold;
  }
  .titles_blocks {
    width: 10px;
    height: 10px;
    margin-left: 10px;
    margin-top: 20px;
  }
  .titles_englis {
    font-size: 14px;
    padding-top: 5px;
  }
  .morese {
    width: 120px;
    height: 40px;
    font-size: 14px;
    cursor: pointer;
  }
}
@media screen and (min-width: 1400px) and (max-width: 1700px) {
  .bodyse {
    width: 1300px;
    margin: 0 auto;
  }
  .bodyse_blocks {
    padding: 50px 0 70px;
  }
  .caseapps {
  }
  .caseapps_items {
    width: 24%;
    margin-right: 1.3%;
  }
  .caseapps_items1 {
    width: 19%;
    margin: 0 1.25% 35px 0;
  }
  .caseapps_items2 {
    width: 19%;
    margin: 0 1.25% 30px 0;
  }
  .caseapps_items_images {
    width: 100%;
    height: 190px !important;
    overflow: hidden;
  }
  .caseapps_items_texts {
    height: 50px;
    padding: 0 12px;
  }
  .caseapps_items_names {
    font-size: 18px;
  }
  .caseapps_items_icons {
    font-size: 18px;
    padding: 4px;
    margin: 0 0 0 4px;
    border: 1px solid #000;
  }
  .caseapps_items_images1 {
    width: 100%;
    height: 180px !important;
    overflow: hidden;
    border: 1px solid #dddddd;
  }
  .caseapps_items_names1 {
    font-size: 16px;
    padding-top: 15px;
    text-align: center;
  }

  .camses {
    width: 330px;
    margin-right: 50px;
  }
  .camses_titles {
    height: 90px;
    padding: 0 25px 0;
    font-size: 20px;
  }
  .camses_lists {
    padding: 0 20px 0 20px;
    height: 65px;
  }
  .camses_lists_texts {
    font-size: 18px;
  }
  .camses_rights {
    text-align: center;
    font-size: 36px;
    font-weight: 700;
    padding: 28px 0;
  }
  .camses_htmls {
    padding: 28px 0;
    border-top: 1px solid #dbdbdb;
  }

  .titles {
    padding: 0 0 45px;
  }
  .titles_texts {
    font-size: 42px;
    font-weight: bold;
  }
  .titles_blocks {
    width: 12px;
    height: 12px;
    margin-left: 12px;
    margin-top: 25px;
  }
  .titles_englis {
    font-size: 16px;
    padding-top: 8px;
  }
  .morese {
    width: 120px;
    height: 45px;
    font-size: 16px;
    cursor: pointer;
  }
}
@media screen and (min-width: 1700px) {
  .bodyse {
    width: 1600px;
    margin: 0 auto;
  }
  .bodyse_blocks {
    padding: 60px 0 85px;
  }
  .caseapps {
  }
  .caseapps_items {
    width: 370px;
    margin-right: 40px;
  }
  .caseapps_items1 {
    width: 285px;
    margin: 0 40px 45px 0;
  }
  .caseapps_items2 {
    width: 255px;
    margin: 0 80px 40px 0;
  }
  .caseapps_items_images {
    width: 100%;
    height: 225px !important;
    overflow: hidden;
  }
  .caseapps_items_texts {
    height: 70px;
    padding: 0 16px;
  }
  .caseapps_items_names {
    font-size: 20px;
  }
  .caseapps_items_icons {
    font-size: 20px;
    padding: 5px;
    margin: 0 0 0 5px;
    border: 1px solid #000;
  }
  .caseapps_items_images1 {
    width: 100%;
    height: 240px !important;
    overflow: hidden;
    border: 1px solid #dddddd;
  }
  .caseapps_items_names1 {
    font-size: 18px;
    padding-top: 20px;
    text-align: center;
  }

  .camses {
    width: 400px;
    margin-right: 60px;
  }
  .camses_titles {
    height: 90px;
    padding: 0 30px 0;
    font-size: 24px;
  }
  .camses_lists {
    padding: 0 25px 0 30px;
    height: 75px;
  }
  .camses_lists_texts {
    font-size: 20px;
  }
  .camses_rights {
    text-align: center;
    font-size: 40px;
    font-weight: 700;
    padding: 30px 0;
  }
  .camses_htmls {
    padding: 30px 0;
    border-top: 1px solid #dbdbdb;
  }

  .titles {
    padding: 0 0 55px;
  }
  .titles_texts {
    font-size: 46px;
    font-weight: bold;
  }
  .titles_blocks {
    width: 16px;
    height: 16px;
    margin-left: 16px;
    margin-top: 30px;
  }
  .titles_englis {
    font-size: 20px;
    padding-top: 10px;
  }
  .morese {
    width: 150px;
    height: 56px;
    font-size: 20px;
    cursor: pointer;
  }
}
.caseapps_items:last-of-type {
  margin-right: 0;
}
.caseapps_items4:nth-child(4n),
.caseapps_items1:nth-child(5n),
.caseapps_items2:nth-child(5n) {
  margin-right: 0 !important;
}
.rotate45 {
  transform: rotate(90deg);
}
.rotate45s {
  transform: rotate(-90deg);
}
.bg1 {
  background: #f5f5f5;
}
.bg2 {
  background: #fff;
}
.bg3 {
  background: #f4f4f4;
}
.bg4 {
  background: #000;
}
.bg5 {
  background: #e9141a;
}
.bg6 {
  background: #e60012;
}
.bg7 {
  background: #242424;
}
.col1 {
  color: #999999;
}
.col2 {
  color: #e9141a;
}
.col3 {
  color: #ffffff;
}
.col4 {
  color: #666666;
}

.box1 {
  box-shadow: 0px 6px 20px 0px rgba(0, 0, 0, 0.2);
}
.none {
  display: none;
}
.block {
  display: block;
}
.flex {
  display: flex;
}
.flex-wrap {
  flex-wrap: wrap;
}
.flex-nowrap {
  flex-wrap: nowrap;
}
.flex-col-center {
  align-items: center;
}
.flex-col-stretch {
  align-items: stretch;
}
.flex-col-top {
  align-items: flex-start;
}
.flex-col-bottom {
  align-items: flex-end;
}
.flex-row-center {
  justify-content: center;
}
.flex-row-left {
  justify-content: flex-start;
}
.flex-row-right {
  justify-content: flex-end;
}
.flex-row-between {
  justify-content: space-between;
}
.flex-row-around {
  justify-content: space-around;
}
.flex-col {
  flex-direction: column;
}
.flex-1 {
  flex: 1;
}
input {
  border: none;
  outline: none;
  background: transparent;
}
.cur_po {
  cursor: pointer;
}
.relative {
  position: relative;
}
.absolute {
  position: absolute;
}
.at0 {
  top: 0;
}
.ar0 {
  right: 0;
}
.al0 {
  left: 0;
}
.ab0 {
  bottom: 0;
}
.w100 {
  width: 100%;
}
.h100 {
  height: 100%;
}
.z10 {
  z-index: 10;
}
.z100 {
  z-index: 100;
}
.marauto {
  margin: 0 auto;
}
.ov_hi {
  overflow: hidden;
}
.ggimgs {
  max-width: 100%;
}
.selector {
  white-space: nowrap;
}
.text-ellipsis-1 {
  white-space: nowrap; /* 保持文本在一行，不换行 */
  overflow: hidden; /* 隐藏超出容器的内容 */
  text-overflow: ellipsis; /* 超出部分显示为省略号 */
}
.text-ellipsis-2 {
  overflow: hidden;
  -webkit-line-clamp: 2;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-box-orient: vertical;
}
.text-ellipsis-3 {
  overflow: hidden;
  -webkit-line-clamp: 3;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-box-orient: vertical;
}

.blocks_images,
.blocks_images1 {
  width: 100%;
  height: 100%;
}
.blocks_images1 .el-image__inner,
.blocks_images2 .el-image__inner {
  transition: all 0.5s ease 0s;
}
.hoverbges {
  transition: all 0.5s ease 0s;
}
.caseapps_items_icons {
  border-radius: 50%;
  transition: all 0.5s ease 0s;
}

.hoves:hover .blocks_images,
.hoves:hover .blocks_images1 .el-image__inner,
.hoves:hover .blocks_images2 .el-image__inner {
  transform: scale(1.1);
}

.hoverbges:hover {
  background: #e9141a;
}
.hovercolor:hover {
  color: #e9141a;
}
.hoves:hover .caseapps_items_names {
  color: #fff;
}
.hoves:hover .caseapps_items_icons {
  border-color: #fff;
  color: #fff;
}
.boxShadows:hover {
  box-shadow: 0px 6px 20px 0px rgba(0, 0, 0, 0.11);
}
.hoves:hover .caseapps_items_texts {
  background: #e9141a;
}
.hoves:hover .caseapps_items_names1 {
  color: #e9141a;
}
.hoves:hover .pagbtns_items_wenzi {
  color: #e9141a;
}
.hoves:hover .icons {
  color: #fff !important;
}
.hoves:hover .caseapps_items_names3 {
  color: #fff;
  background: #e9141a;
}

.scrolsimga {
  width: 100%;
  height: 100%;
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;
}
.scrolsimga1 {
  width: 100%;
  height: 100%;
  background-repeat: no-repeat;
  background-size: contain;
  background-position: center;
}
.icons1 {
  background-image: url("@/assets/icons1.png");
}
</style>
